import { Typography } from "@mui/material";
import React from "react";

const ColumnRowIndex = ({ rowIndex }) => {
  return (
    <Typography
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {rowIndex}
    </Typography>
  );
};

export default ColumnRowIndex;
